import { cn } from '@/components/ui';
import { HIGHLIGHT_GLYPHS } from './HighlightGlyphs';
import { resolveHighlightIconId, type HighlightIconId } from './highlightIconIds';

export type HighlightIconProps = {
  /** Semantic id (`shield`, `chart-trend`) or legacy emoji — resolved at render time. */
  name?: string | null;
  className?: string;
  size?: number;
};

export function HighlightIcon({ name, className, size = 24 }: HighlightIconProps) {
  const id: HighlightIconId = resolveHighlightIconId(name) ?? 'layers';
  const Glyph = HIGHLIGHT_GLYPHS[id];
  return (
    <Glyph
      className={cn('highlight-icon', className)}
      width={size}
      height={size}
    />
  );
}

/** Icon inside the standard highlight card chip (string id or legacy emoji). */
export function HighlightIconChip({
  name,
  className,
  size = 24,
}: HighlightIconProps) {
  if (!name) return null;
  return (
    <span className={cn('page-highlight-icon', className)} aria-hidden>
      <HighlightIcon name={name} size={size} />
    </span>
  );
}
